import React, { useEffect, useState } from "react";
import {  Globals as oldGlobals } from "../../global/Globals";
import "./Sessionpopup.css";
import { useUnauthorized } from "../../context/Unauthorisedcontext";
import { deleteCookie } from "../../util/util";
import { useLanguage } from "../../context/Languagecontext";

const Sessionpopup = (props) => {
  const { Globals} = useLanguage();
  const { isUnauthorized, setIsUnauthorized } = useUnauthorized();

  if (!isUnauthorized) return null;
  
  const handleClick = () => {
    setIsUnauthorized(false);
     localStorage.clear();
     deleteCookie(Globals.JWT_TOKEN_NAME);
    window.location.href = '/';
    document.body.style.overflow = "auto";
  };

  return (
    <>
        <div className="popup">
          <div className="session-popup-bg-cover">
            <div className="session-popup-bg-content">
            <div className="session-popup-title">
              <h4>{Globals.SESSIONOUT_HEADER}</h4>
              <img className={`sessionpopup-close-button`} src={oldGlobals.IMG.CLOSE} onClick={handleClick} />
            </div>
            <div className="session-popup-content">
              <div className="session-popup-content-text">
               {Globals.SESSIONOUT_CONTENT_TEXT}
              </div>
            </div>
            <div className="session-popup-fotter">
              <button className={`session-popup-action`} onClick={handleClick}>{Globals.SESSIONOUT_ACTION_BTN}</button>
            </div>
            </div>
          </div>
        </div>
    </>
  );
};

export default Sessionpopup;
